import { fork, put, take, takeLatest } from 'redux-saga/effects';

import {
    REQUEST_COMPANY_LOOKUP,
    REQUEST_COMPANY_LOOKUP_COMPLETED,
    REQUEST_COMPANY_LOOKUP_LOADING,
    SUBMIT_COMPANY_DETAILS,
    SUBMIT_COMPANY_DETAILS_COMPLETED,
    SUBMIT_COMPANY_DETAILS_LOADING
} from './CompanyDetails.actions';
import { selectAPI } from '../../../api/API.sagas';
import { serialiseCompany } from '../../../api/lendingAPI/CustomerStateAPIHelper';
import {
    API_GET_COMPANY_LOOKUP,
    API_GET_COMPANY_LOOKUP_PENDING,
    API_GET_COMPANY_LOOKUP_SUCCESS,
    API_GET_CUSTOMER_STATE_EDIT,
    API_SAVE_CUSTOMER_STATE,
    API_SAVE_CUSTOMER_STATE_SUCCESS
} from '../../../api/lendingAPI/LendingAPI.actions';
import { CANCEL_PROMPT } from '../Profile.actions';

export const companyDetailsSagasWorker = [
    fork(updateCompanyDetailsSagasWorker),
    fork(companySearchWorker)
];

function* companySearchWorker() {
    yield takeLatest(REQUEST_COMPANY_LOOKUP, function* (action) {
        yield put({ type: REQUEST_COMPANY_LOOKUP_LOADING });
        yield put({ type: API_GET_COMPANY_LOOKUP_PENDING });
        yield put({ type: API_GET_COMPANY_LOOKUP, company: action.company });

        yield take(API_GET_COMPANY_LOOKUP_SUCCESS);

        const { company_lookup } = yield selectAPI();
        yield put({
            type: REQUEST_COMPANY_LOOKUP_COMPLETED,
            companies: company_lookup
        });
    });
}

function* updateCompanyDetailsSagasWorker() {
    yield takeLatest(SUBMIT_COMPANY_DETAILS, function* (action) {
        yield put({ type: SUBMIT_COMPANY_DETAILS_LOADING });

        const { customer_state } = yield selectAPI();
        const previousCompanyState = customer_state?.application?.company;

        const newCompanyState = serialiseCompany(
            previousCompanyState,
            action.companyDetails
        );

        yield put({
            type: API_GET_CUSTOMER_STATE_EDIT,
            data: {
                application: {
                    company: newCompanyState
                }
            }
        });

        yield put({ type: API_SAVE_CUSTOMER_STATE });
        yield take(API_SAVE_CUSTOMER_STATE_SUCCESS);

        yield put({ type: SUBMIT_COMPANY_DETAILS_COMPLETED });
        yield put({ type: CANCEL_PROMPT });
    });
}
